import { Box, makeStyles, TextField, Typography } from '@material-ui/core';

export const InputControlled = ({
  label,
  value,
  onChange,
  placeholder,
  type = 'text',
  variant = 'outlined',
  size = 'small',
  fullWidth = true,
  name,
  sxContainer,
  ...rest
}) => {
  const classes = useStyles();
  return (
    <Box width={fullWidth ? '100%' : 'auto'} className={classes.inputContainer} sx={sxContainer}>
      <Typography className={classes.label}>{label}</Typography>
      <TextField
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        type={type}
        variant={variant}
        size={size}
        fullWidth={fullWidth}
        InputProps={{
          className: classes.input,
        }}
        name={name}
        {...rest}
        margin="none"
      />
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  input: {
    display: 'flex',
    height: '34px',
    padding: '10px 0px',
    alignItems: 'center',
    gap: '8px',
    alignSelf: 'stretch',
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    fontSize: '1rem',
    fontWeight: 500,
  },
}));
